import { ButtonSecondary } from "components/Atoms/Button";
import { Panel } from "components/panels";
import PanelSegment from "components/panels/PanelSegment/PanelSegment";
import React from "react";
import { useCustomQuery, useManualPagination } from "utilities/hookutils";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  userToClient: server.dto.UserToClientSmall
}

const ICalendarFeedsPanel = (props: Props) => {
  const [isSendingEmail, setIsSendingEmail] = React.useState<boolean>(false);
  const [instruction, setInstruction] = React.useState<server.dto.ListICalendarFeedInstruction>({
    page: 1,
    perPage: 10,
    ownerUserToClientId: props.userToClient.userToClientId,
  });

  const onEmailFeedClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (isSendingEmail) {
      return;
    }

    setIsSendingEmail(true);
    window.CoreApi.ICalendarFeed.EmailOverview(props.userToClient.user.userId)
      .then(() => {
        window.displayGenericModal(RESX.Message.EmailSent, RESX.GeneralWarnings.AnEmailHasBeenSentToInformTheUser, "small");
      })
      .finally(() => {
        setIsSendingEmail(false);
      });
  };

  const api = useCustomQuery({
    queryFn: async () => window.CoreApi.ICalendarFeed.List(instruction),
    queryKey: ["iCalendarFeeds", instruction],
    onSuccess: (response) => {
      pagination.setPagination(response.data.pagination);
    }
  });

  const paginate = (paginationData: Partial<server.dto.PaginationData>) => {
    setInstruction({
      ...instruction,
      page: paginationData.page,
      perPage: paginationData.perPage
    });
  };

  const pagination = useManualPagination(instruction.page || 1, 10, paginate);
  const items = api.data?.data?.data || [];

  return <Panel
    title={RESX.Feed.iCalendarFeed}
    panelClassName="s1_related-feature-panel"
    articleId={serverReference.supportArticleIds.iCalendarFeeds}
    isLoading={api.isLoading}
    hasData={api.data?.data?.pagination.total > 0}
  >
    {pagination && <div className="flex justify-end">
      <PanelSegment.Pagination>{pagination.Component}</PanelSegment.Pagination>
    </div>}

    <div className="s1-linked-items-row flex-column gap-mini">
      {items.map(item => <a
        style={{ textDecoration: "none" }}
        key={item.iCalendarFeedId}
        className="hoverable flex"
        href={routes.systemSetting_ICalendarFeed_Detail(props.userToClient.userToClientId, item.iCalendarFeedId).absolute}
      >
        {item.title}
      </a>)}
    </div>

    <div className="flex justify-end margin-top-large">
      <ButtonSecondary
        onClick={onEmailFeedClick}
        label={RESX.Feed.EmailFeedOverview}
      />
    </div>
  </Panel>;
};

export default ICalendarFeedsPanel;
